import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { CustomerForm } from "../../../../components/secondaryComponents/customers";
import { useGetCustomerDetails } from "../../../../hooks/api/queries";
import secondaryComponents from "../../../../components/secondaryComponents";

const UpdateCustomer = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { data: customerDetails, isLoading } =
    useGetCustomerDetails(customerId);

  return (
    <RoutedModal
      isActive={true}
      width={800}
      headerTitle="Add New Customer"
      closeModal={() => navigate(-1)}
      style={{ height: "auto" }}
    >
      <secondaryComponents.LoaderHelper
        isLoading={isLoading}
        classNames={"mt-5"}
      >
        <CustomerForm
          customerInfo={customerDetails}
          isEditMode={true}
          closeModal={() => navigate(-1)}
        />
      </secondaryComponents.LoaderHelper>
    </RoutedModal>
  );
};
export default UpdateCustomer;
